import {Observable} from 'rxjs';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';
import {ApiV0} from '../../api.v0';
import {RestApiService} from '../../../rest-api.service';
import {BillingDocumentFinalizePreviewRes, BillingDocumentFinalizeReq, InvoiceDetailRes} from '../../../../contracts/v0/cp/invoice.contract';
import {
    OfferCreateReq,
    OfferDecisionReq,
    OfferDetailRes,
    OfferProjectSourceReq,
    OfferProjectSourceRes,
    OfferSendReq,
    OfferUpdateReq,
} from '../../../../contracts/v0/cp/offer.contract';

export class ApiV0Offer {
    segment = '/offer';
    constructor(v0: ApiV0, private rest: RestApiService) { this.segment = v0.segment + this.segment; }

    search(req: SearchModel = new SearchModel({})): Observable<BaseCollectionModel<OfferDetailRes>> {
        return this.rest.post<SearchModel, BaseCollectionModel<OfferDetailRes>>(`${this.segment}/search`, OfferDetailRes, req);
    }
    createDraft(req: OfferCreateReq): Observable<OfferDetailRes> {
        return this.rest.post<OfferCreateReq, OfferDetailRes>(`${this.segment}/Draft`, OfferDetailRes, req);
    }
    add(req: OfferCreateReq): Observable<OfferDetailRes> {
        return this.rest.post<OfferCreateReq, OfferDetailRes>(this.segment, OfferDetailRes, req);
    }
    update(id: number, req: OfferUpdateReq): Observable<OfferDetailRes> {
        return this.rest.patch<OfferUpdateReq, OfferDetailRes>(`${this.segment}/${id}`, OfferDetailRes, req);
    }
    finalizePreview(id: number): Observable<BillingDocumentFinalizePreviewRes> {
        return this.rest.post<Record<string, never>, BillingDocumentFinalizePreviewRes>(
            `${this.segment}/${id}/FinalizePreview`,
            BillingDocumentFinalizePreviewRes,
            {},
        );
    }
    finalize(id: number, req: BillingDocumentFinalizeReq): Observable<OfferDetailRes> {
        return this.rest.post<BillingDocumentFinalizeReq, OfferDetailRes>(`${this.segment}/${id}/Finalize`, OfferDetailRes, req);
    }
    send(id: number, req: OfferSendReq): Observable<OfferDetailRes> {
        return this.rest.post<OfferSendReq, OfferDetailRes>(`${this.segment}/${id}/Send`, OfferDetailRes, req);
    }
    accept(id: number, req: OfferDecisionReq = new OfferDecisionReq()): Observable<OfferDetailRes> {
        return this.rest.post<OfferDecisionReq, OfferDetailRes>(`${this.segment}/${id}/Accept`, OfferDetailRes, req);
    }
    reject(id: number, req: OfferDecisionReq = new OfferDecisionReq()): Observable<OfferDetailRes> {
        return this.rest.post<OfferDecisionReq, OfferDetailRes>(`${this.segment}/${id}/Reject`, OfferDetailRes, req);
    }
    cancel(id: number): Observable<OfferDetailRes> {
        return this.rest.post<Record<string, never>, OfferDetailRes>(`${this.segment}/${id}/Cancel`, OfferDetailRes, {});
    }
    projectSource(req: OfferProjectSourceReq): Observable<OfferProjectSourceRes> {
        return this.rest.post<OfferProjectSourceReq, OfferProjectSourceRes>(`${this.segment}/ProjectSource`, OfferProjectSourceRes, req);
    }
    createInvoice(id: number): Observable<InvoiceDetailRes> {
        return this.rest.post<Record<string, never>, InvoiceDetailRes>(`${this.segment}/${id}/Invoice`, InvoiceDetailRes, {});
    }
    deleteDraft(id: number): Observable<void> { return this.rest.delete<void>(`${this.segment}/${id}`); }
}
